<script setup lang="ts">
import type { Component } from 'vue';
import AtButton from '@/components/atoms/AtButton/AtButton.vue';

type Action = {
  label: string;
  onClick: () => void;
  loading?: boolean;
};

type Props = {
  title: string;
  icon: Component;
  variant: 'default' | 'center';
  primaryAction?: Action;
  secondaryActions?: Action[];
};

defineProps<Props>();
</script>

<template>
  <div class="bg-gray-50 rounded-md px-6 pt-[72px] pb-10">
    <component :is="icon" class="w-24 h-24 mx-auto text-gray-200 mb-9" />
    <p class="font-bold text-gray-900 mb-8 text-center">
      {{ title }}
    </p>
    <div
      class="mb-16"
      :class="{ 'mb-16 mx-auto text-center max-w-lg': variant === 'center' }"
    >
      <slot />
    </div>
    <div
      v-if="primaryAction || secondaryActions"
      class="flex space-x-6 items-center"
      :class="{
        'justify-between': secondaryActions,
        'justify-end': !secondaryActions,
      }"
    >
      <div v-if="secondaryActions" class="flex items-center space-x-6">
        <AtButton
          v-for="action of secondaryActions"
          :key="action.label"
          type="button"
          variant="outline"
          :loading="action.loading ?? false"
          @click="action.onClick"
        >
          {{ action.label }}
        </AtButton>
      </div>

      <AtButton
        v-if="primaryAction"
        type="button"
        :loading="primaryAction.loading ?? false"
        @click="primaryAction.onClick"
      >
        {{ primaryAction.label }}
      </AtButton>
    </div>
  </div>
</template>
